
import React from "react";

function About() {
  return (
    <>
     {/* =========================
          ABOUT SECTION
      ========================== */}
      <section id="about">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <div className="about-image">
                <img
                  src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=900&q=80"
                  className="img-fluid"
                  alt="Healthcare Team"
                />

                <div className="experience-box">
                  <h2>25+</h2>
                  <span>Years of Excellence</span>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <span className="section-subtitle">ABOUT US</span>

              <h2 className="section-title">
                Compassionate Healthcare Backed by Experience
              </h2>

              <p className="section-text">
                Dr. Sadhana Kumar is a nephrologist in Parsippany, New Jersey
                and is affiliated with multiple hospitals in the area,
                including CarePoint Health Hoboken University Medical Center
                and Clara Maass Medical Center. She received her medical
                degree from Osmania Medical College NTR UHS and has been in
                practice for more than 25 years.
              </p>

              <div className="row mt-4">
                <div className="col-md-6">
                  <div className="info-card">
                    <i className="bi bi-bullseye"></i>

                    <h5>Our Mission</h5>

                    <p>
                      Deliver patient-centered healthcare with excellence,
                      integrity, and innovation.
                    </p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="info-card">
                    <i className="bi bi-eye-fill"></i>

                    <h5>Our Vision</h5>

                    <p>
                      Building healthier communities through accessible and
                      compassionate medical care.
                    </p>
                  </div>
                </div>
              </div>

              <div className="feature-list mt-5">
                <div className="feature-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>Board Certified Specialists</span>
                </div>

                <div className="feature-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>Modern Medical Technology</span>
                </div>

                <div className="feature-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>24/7 Emergency Assistance</span>
                </div>

                <div className="feature-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <span>Personalized Treatment Plans</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section></>)
  ;
}

export default About;